import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { DispatchFunction, RootState } from '../types'
import { useEffect, useState } from 'react'
import { property } from 'lodash/fp'
import { ObjPropType, Paths } from './type-helpers'

export const useAppDispatch = () => useDispatch<DispatchFunction>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay ?? 500)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}

export const get =
  <P extends Paths<RootState>>(path: P) =>
  (obj: RootState): ObjPropType<P extends string ? P : never, RootState> =>
    property((path ?? '').split('.'))(obj)

export const useGetStore = <P extends Paths<RootState>>(path: P) => useAppSelector(get(path))
